export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fc4507d84ffd06759c1a1f8'
  }
};

export const QUERY = `
  query billsOne ($filter: AutoFilledFilterFindOnebillsInput!, $skip: Int, $sort: SortFindOnebillsInput) {
    billsOne (filter: $filter, skip: $skip, sort: $sort) {
        companyId
        invoiceId
        vendorId
        status
        allowedPaymentTypes
        currency
        total
        paid
        amountDue
        amountPaid
        metadata
        _id
        updatedAt
        createdAt
    }
  }
`;
